export const GLOBAL_LOOPS_RESET_STATE = 'GLOBAL_LOOPS_RESET_STATE';
export const GLOBAL_LOOPS_CURRENT_ITEM = 'GLOBAL_LOOPS_CURRENT_ITEM';

export const GLOBAL_LOOPS_REQUEST_LOADING = 'GLOBAL_LOOPS_REQUEST_LOADING';
export const GLOBAL_LOOPS_REQUEST_SUCCESS = 'GLOBAL_LOOPS_REQUEST_SUCCESS';
export const GLOBAL_LOOPS_REQUEST_FAILED = 'GLOBAL_LOOPS_REQUEST_FAILED';

export const GLOBAL_LOOPS_CURRENT_ACTION = 'GLOBAL_LOOPS_CURRENT_ACTION';
export const GLOBAL_LOOPS_RESET_ACTION = 'GLOBAL_LOOPS_RESET_ACTION';